module.exports = __webpack_public_path__ + "static/img/policyType7-banner.afa4f1d1.png";